import React from 'react'
// import Navbar from './Ui/Navbar'  
import Home from './Ui/Home'

const Main = () => {
  return (
     <div className=' max-w-screen-xl mx-auto' >
  {/* <Navbar/>  */}
<Home/>
</div>
  )
}

export default Main